module.exports = __webpack_public_path__ + "static/media/Guardian.daffa8aa.png";